import { SERVER_ROUTES } from "../../enums/Enums";
import * as axiosActions from "../../managers/Axios/AxiosActions";
import { trackException } from "../Azure/ApplicationInsightsActions";

export const deleteCarUserToken = (carUserTokenId, isShowSpinner = true, closeSpinner = true) => {
    return new Promise((resolve, reject) => {
      var queryParams = carUserTokenId;
  
      axiosActions
        .DELETE(SERVER_ROUTES.CAR_USER_TOKEN + queryParams, isShowSpinner, closeSpinner)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          trackException("ActionsService.js - deleteCarUserToken()", error);
          reject(error);
        });
    });
  };

  export const removeCarUserToken = (carUserTokenEntity, isShowSpinner = true, closeSpinner = true) => {
    return new Promise((resolve, reject) => {
      var requestBody = carUserTokenEntity;
  
      axiosActions
        .DELETE(SERVER_ROUTES.CAR_USER_TOKEN_DELETE, requestBody, isShowSpinner, closeSpinner)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          trackException("ActionsService.js - removeCarUserToken()", error);
          reject(error);
        });
    });
  };

  export const deleteCarUserTokensByTokenId = (tokenId, isShowSpinner = true, closeSpinner = true) => {
    return new Promise((resolve, reject) => {
      var queryParams = tokenId;
  
      axiosActions
        .DELETE(SERVER_ROUTES.DELETE_TOKEN + queryParams, isShowSpinner, closeSpinner)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          trackException("ActionsService.js - deleteCarUserTokensByTokenId()", error);
          reject(error);
        });
    });
  };

  export const updateCarUserToken = (updateCarUserTokenEntity, isShowSpinner = true, closeSpinner = true) => {
    return new Promise((resolve, reject) => {
      var requestBody = updateCarUserTokenEntity;
  
      axiosActions
        .PUT(SERVER_ROUTES.CAR_USER_TOKEN, requestBody, isShowSpinner, closeSpinner)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          trackException("ActionsService.js - updateCarUserToken()", error);
          reject(error);
        });
    });
  };

  export const updateCarUserTokensActivation = (updateCarUserTokenActivationEntity, isShowSpinner = true, closeSpinner = true) => {
    return new Promise((resolve, reject) => {
      var requestBody = updateCarUserTokenActivationEntity;
  
      axiosActions
        .PUT(SERVER_ROUTES.CAR_USER_TOKEN_ACTIVATION, requestBody, isShowSpinner, closeSpinner)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          trackException("ActionsService.js - updateCarUserTokensActivation()", error);
          reject(error);
        });
    });
  };

  export const assignCarUserToken = (carUserTokenOperationsEntity, isShowSpinner = true, closeSpinner = true) => {
    return new Promise((resolve, reject) => {
      var requestBody = carUserTokenOperationsEntity;
  
      axiosActions
        .POST(SERVER_ROUTES.ASSIGN_CAR_USER_TOKEN, requestBody, isShowSpinner, closeSpinner)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          trackException("ActionsService.js - assignCarUserToken()", error);
          reject(error);
        });
    });
  };

  export const assignCommonCarUserTokens = (carUserTokenOperationsEntity, isShowSpinner = true, closeSpinner = true) => {
    return new Promise((resolve, reject) => {
      var requestBody = carUserTokenOperationsEntity;
  
      axiosActions
        .POST(SERVER_ROUTES.ASSIGN_COMMON_CAR_USER_TOKENS, requestBody, isShowSpinner, closeSpinner)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          trackException("ActionsService.js - assignCommonCarUserTokens()", error);
          reject(error);
        });
    });
  };